import moment from 'moment';
import { htmlToText } from 'html-to-text';
import { getUserShortName } from '../../utils/helpers';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Review = function Review(_ref) {
  var _review$user, _review$user2;

  var review = _ref.review;
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-white w-full max-w-2xl border border-gray-100 rounded-lg p-6 mt-4",
    children: [/*#__PURE__*/_jsx("h6", {
      className: "text-base font-medium m-0",
      children: getUserShortName(review === null || review === void 0 ? void 0 : (_review$user = review.user) === null || _review$user === void 0 ? void 0 : _review$user.firstName, review === null || review === void 0 ? void 0 : (_review$user2 = review.user) === null || _review$user2 === void 0 ? void 0 : _review$user2.lastName)
    }), /*#__PURE__*/_jsx("span", {
      className: "block text-sm text-gray-500 font-normal mb-4",
      children: moment(review.createdAt).format('MMMM D, YYYY')
    }), /*#__PURE__*/_jsxs("p", {
      className: "m-0 text-base text-gray-700 font-normal",
      children: ["\u201C", htmlToText(review.text), "\u201D"]
    })]
  }, review.id);
};
Review.defaultProps = {};